module.exports = __webpack_public_path__ + "zilla-slab-latin-600italic.cb82fcf82ebe3d96ac365179abe1e779.woff2";